// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"SelectFieldCustom_closeIcon__3Rf8u","popoverPlaceholder":"SelectFieldCustom_popoverPlaceholder__3YDIt"};